// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-field {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
}

.input-field input {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background: #CFCCCB;
  border-radius: 15px;
  font-size: 20px;
  outline: none;
  border: none;
}

.input-field label {
  position: absolute;
  top: 10px;
  left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.2rem;
  color: #4d4c4c;
  pointer-events: none;
}

@media (max-width: 768px) {
  .input-field input {
    font-size: 12px;
  }

  .input-field label {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/inputField/InputField.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".input-field {\n  position: relative;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.input-field input {\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  background: #CFCCCB;\n  border-radius: 15px;\n  font-size: 20px;\n  outline: none;\n  border: none;\n}\n\n.input-field label {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.2rem;\n  color: #4d4c4c;\n  pointer-events: none;\n}\n\n@media (max-width: 768px) {\n  .input-field input {\n    font-size: 12px;\n  }\n\n  .input-field label {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
